<template>
    <div class="qesg-dashboard">
        <!-- sidebar -->
        <div :class="['qesg-sidebar', { collapsed: collapsedSidebar }, 'd-flex flex-column', 'border-right border-color-gray-300']">
            <div class="qesg-sidebar__header">
                <b-navbar-brand :to="{ name: 'ContractorProgress',   params: {
                                requestsId: Get_Contractor.company_id,
                            },
                            query: {
                                projectid: $route.query.projectid
                            } }" class="mr-0">
                    <b-img src="/images/QESG_Assessment_basic.svg" width="120" />
                </b-navbar-brand>
            </div>
            <div class="qesg-sidebar__body">
                <b-nav v-if="Get_Contractor.company_id" class="w-100 dashboard-nav" vertical>
                    <b-nav-item
                        :to="{
                            name: 'ContractorProgress',
                            params: {
                                requestsId: Get_Contractor.company_id,
                            },
                            query: {
                                projectid: $route.query.projectid
                            }
                        }"
                        class="w-100 mb-2"
                        link-classes="h5 mb-0"
                        :active="$route.name === 'ContractorProgress'"
                        :disabled="disabledLayoutGlobal"
                        >
                        <div class="d-flex align-items-center">
                            <BIconHouseDoorFill font-scale="1" class="mr-3" />
                            {{ $t('진행 현황') }}
                        </div>
                    </b-nav-item>
                    <b-nav-item
                        :to="{
                            name: 'ContractorReport',
                            params: {
                                requestsId: Get_Contractor.company_id,
                            },
                             query: {
                                projectid: $route.query.projectid
                            }
                        }"
                        class="w-100 mb-2"
                        link-classes="h5 mb-0"
                        :active="$route.name === 'ContractorReport'"
                        :disabled="disabledLayoutGlobal"
                        >
                        <div class="d-flex align-items-center">
                            <BIconInfoCircle font-scale="1" class="mr-3" />
                            {{ $t('평가 결과') }}
                        </div>
                    </b-nav-item>
                    <b-nav-item
                        v-if="checkAppEnv() === 'hmc'"
                        :to="{
                            name: 'ContractorActionPlan',
                            params: {
                                requestsId: Get_Contractor.company_id,
                            },
                             query: {
                                projectid: $route.query.projectid
                            }
                        }"
                        class="w-100 mb-2"
                        link-classes="h5 mb-0"
                        :active="$route.name === 'ContractorActionPlan'"
                        :disabled="disabledLayoutGlobal"
                    >
                        <div class="d-flex align-items-center">
                            <BIconFileEarmarkTextFill font-scale="1" class="mr-3" />
                            <span :style="{ fontSize: $i18n.locale === 'en' ? '1.1rem' : '1.25rem' }">
                                {{ $t('개선계획 제출 현황') }}    
                            </span>
                        </div>
                    </b-nav-item>
                </b-nav>
            </div>
            <div class="qesg-sidebar__footer border-top border-color-gray-300 mt-auto py-2 text-right p-3">
                <b-btn variant="light" @click="collapsedSidebar = !collapsedSidebar">
                    <b-icon-chevron-bar-left  v-show="!collapsedSidebar" />
                    <b-icon-chevron-bar-right v-show="collapsedSidebar" />
                </b-btn>
            </div>
        </div>

        <!-- body -->
        <div class="position-relative">
            <contractor-navigation-bar
                :isProjectLoaded="disabledLayoutGlobal"
                :collapsedSidebar="collapsedSidebar"
                :projectListError="projectListError"
                @collapseSidebar="collapsedSidebar = !collapsedSidebar"
                @retry="loadProjects"
                />
            <div :class="['qesg-body position-relative px-md-3 py-md-4 mt-3 mt-md-0', { collapsed: collapsedSidebar }]">
                <b-container fluid class="mb-5">

                    <!-- 에러 Alert 카드 -->
                    <b-row v-if="!isPageDataLoading && showErrorMeassage.state" class="mb-4">
                        <b-col cols="12">
                            <b-card bg-variant="danger" text-variant="white">
                                <div class="d-flex align-items-center">
                                    <BIconInfoCircle class="d-inline-block h3 mb-0 mr-3" />
                                    <div class="d-inline-block mb-0">
                                        <p class="mb-1"> {{ showErrorMeassage.message }} </p>
                                        <h5 class="mb-0"> 알수 없는 에러가 발생했습니다. 재접속 해주세요. </h5>
                                    </div>
                                    <div class="ml-auto">
                                        <b-btn variant="light"
                                            @click="onRecover"
                                            >
                                            페이지 새로고침
                                        </b-btn>
                                    </div>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols="12" md="6" class="mb-3 mb-md-0">
                            <div class="d-flex align-items-end justify-content-start h-100">
                                <h1 class="ml-1 mb-0 gray-500" :style="{ fontSize: $i18n.locale === 'en' ? '2.3rem' : '2.5rem' }">{{ $t($route.meta.title_kr) }}</h1>
                            </div>
                        </b-col>
                        <b-col cols="12" md="6">
                            <div class="d-flex align-items-end justify-content-start justify-content-md-end h-100">
                                <div v-show="GET_CONTRACTOR_REQEUST_TIME" class="font-weight-normal mb-0 py-2 px-3 bg-white text-secondary rounded shadow-xs">
                                    {{ $t('최근 조회 시간') }}: {{ requestTime }}
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
                <router-view
                    :loadedRequiredData="dataLoaded.initial"
                    @emit-loaded-status="onLoadedStatus"
                    @emit-error-status="onErrorStatus"
                    />
            </div>
        </div>
        <back-drop :show="disabledLayoutGlobal" class="positon-relative">
            <template v-if="isPageDataLoading">
                <b-spinner
                    label="Loading..."
                    :style="{ height: '4rem', width: '4rem' }"
                    variant="light"
                    >
                </b-spinner>
            </template>
        </back-drop>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters, mapMutations } from 'vuex';
import { BIconChevronBarLeft, BIconChevronBarRight, BIconHouseDoorFill } from 'bootstrap-vue';
import ContractorNavigationBar from '@shared_components/contractor/components/contractor-navigation-bar';
import backDrop from '@shared_components/common/backdrop.vue';
import {checkAppEnv} from '@shared/utils/common';

export default {
    name: 'layout-contractor',
    components: {
        BIconChevronBarLeft,
        BIconChevronBarRight,
        BIconHouseDoorFill,
        ContractorNavigationBar,
        backDrop
    },
    data () {
        return {
            initialLoading: true,
            loadingStatus: false,
            collapseProjectsNavList: true,
            collapsedSidebar: false,
            dataLoaded: {
                initial: false,
                content: false
            },
            showErrorMeassage: {
                state: false,
                type: null,
                message: null
            },
            is_inCollapsed_risk_monitoring_nav_group: true,
            projectListError: false
        };
    },
    computed: {
        ...mapGetters('contractor', ['Get_Contractor', 'GET_ProjectList', 'GET_CONTRACTOR_REQEUST_TIME']),
        contractorInfo () {
            return {
                user_id: localStorage.getItem('user_id'),
                company_id: localStorage.getItem('company_id'),
            };
        },
        isLatestProjectNavActive () {
            return !this.GET_ProjectList.length ? false : [this.GET_ProjectList[0].project_code, 'latest'].includes(this.$route.params.projectid);
        },
        isPageDataLoading () {
            return Object.values(this.dataLoaded).some(_loaded => _loaded === false);
        },
        disabledLayoutGlobal () {
            return Object.values(this.dataLoaded).some(_loaded => _loaded === false);
        },
        isActiveRiskMonitoringNavGroup() {
            return ['RiskMonitoring','RiskDetailed'].includes(this.$route.name);
        },
        requestTime() {
            return this.GET_CONTRACTOR_REQEUST_TIME
                ? this.$i18n.locale === 'ko'
                    ? dayjs(this.GET_CONTRACTOR_REQEUST_TIME).format('YYYY년 MM월 DD일 HH:mm:ss')
                    : dayjs(this.GET_CONTRACTOR_REQEUST_TIME).format('MM / DD / YYYY HH:mm:ss')
                : null;
        }
    },
    watch: {
        'showErrorMeassage.state' (_state) {
            if (!_state) {
                this.initializeErrorMeassage();
            }
        },
    },
    created () {
        this.dataLoaded.initial = false;
        const _is_empty_contractor_account_store = Object.values(this.Get_Contractor).every(_info => _info === null);
        if (_is_empty_contractor_account_store) {
            const _account = {};
            Object.keys(this.Get_Contractor).forEach(_account_key => {
                const _account_data = localStorage.getItem(_account_key);
                _account[_account_key] = _account_data;
            });

            const _is_empty_contractor_account = Object.values(_account).every(_info => _info === null);
            if (!_is_empty_contractor_account) {
                this.SET_CONTRACTOR_ACCOUNT(_account);
            }
        }
    },
    async mounted () {
        this['$dashboard-error-bus'].$on(_error_obj_set => {
            this.onErrorStatus(_error_obj_set);
        });
        document.body.classList.add('bgray-100');
        await this.loadProjects();
    },
    beforeDestroy () {
        document.body.classList.remove('bgray-100');
        this.SET_PROJECT_LIST([]);
    },
    methods: {
        checkAppEnv,
        ...mapMutations('contractor', ['SET_CONTRACTOR_ACCOUNT', 'SET_PROJECT_LIST', 'SET_PROJECT']),
        async loadProjects () {
            try {
                this.dataLoaded.initial = false;
                this.projectListError = false;
                const _res_company_project_list = await this.$projectsAxios.get('/accessible');
                if (_res_company_project_list.data) {
                    _res_company_project_list.data.forEach(_project => {
                        if (_project.period && _project.period.includes('_')) {
                            let _active_project_period = _project.period.split('_');
                            _active_project_period[0] = dayjs(_active_project_period[0]).format('YYYY');
                            _active_project_period[1] = _active_project_period[1].replace(/h/gi, '');
                            _project.period_dis = {
                                ko: `${_active_project_period[0]}년 ${_active_project_period[1] === '1' ? '상반기' : '하반기'}`,
                                en: `H${_active_project_period[1]} ${_active_project_period[0]}`,
                                ca: `${_active_project_period[0]}年${_active_project_period[1] === '1' ? '上半年' : '下半年'}`
                            };
                            _project.project_company_num = !_project.project_company_num ? 0 : _project.project_company_num;
                        }
                    });
                }

                this.SET_PROJECT_LIST(_res_company_project_list.data);
                // 목록에 없는 projectid(공유 링크·권한 변경)는 첫 프로젝트로 보정한다
                const _query_projectid = this.$route.query.projectid;
                const _is_valid_projectid = this.GET_ProjectList.some(_project => _project.project_code === _query_projectid);
                const current_project_code = _is_valid_projectid ? _query_projectid : this.GET_ProjectList?.[0]?.project_code;
                this.SET_PROJECT(current_project_code);

                if(_query_projectid !== current_project_code) {
                    await this.$router.replace({name: this.$route.name ?? 'ContractorProgress', params: this.$route.params, query: { ...this.$route.query, projectid: current_project_code }});
                    if (_query_projectid) {
                        this.$EventBus.$emit('toast-warning', this.$t('프로젝트 변경'), this.$t('요청한 프로젝트를 찾을 수 없거나 권한이 없어 최신 프로젝트로 이동했습니다.'));
                    }
                }
            } catch (error) {
                this.SET_PROJECT_LIST([]);
                this.SET_PROJECT(null);
                this.projectListError = true;
            } finally {
                this.dataLoaded.initial = true;
            }
        },
        // 현재 query 를 버리지 않고 첫 프로젝트로 복귀한다. 이미 그 화면이면 데이터를 다시 받기 위해 새로고침한다
        onRecover () {
            const _projectid = this.GET_ProjectList?.[0]?.project_code;
            if (this.$route.name === 'ContractorProgress' && this.$route.query.projectid === _projectid) {
                window.location.reload();
                return;
            }
            this.$router.push({
                name: 'ContractorProgress',
                params: { requestsId: this.Get_Contractor.company_id },
                query: { projectid: _projectid }
            }).then(() => this.initializeErrorMeassage()).catch(() => {});
        },
        onLoadedStatus (status) {
            // 새 요청이 시작되면 이전 오류 배너를 걷는다 (오류는 요청 종료 전에 다시 발행됨)
            if (status === false) {
                this.initializeErrorMeassage();
            }
            this.dataLoaded.content = status;
        },
        onErrorStatus ({ status: _error_state, message: _error_msg }) {

            if (process.env.BUILD_NODE_ENV !== 'production') {
                console.log('onErrorStatus ~ ');
                console.log(` ~ _error_state =>  ${_error_state}`);
                console.log(` ~ _error_msg =>  ${_error_msg}`);
            }
            
            const _error_obj_set = {
                'not-allowed': '권한이 없거나 존재하지 않는 프로젝트 입니다.',
                'not-recognized': '알수 없는 에러가 발생했습니다. 재접속 해주세요.'
            };

            this.showErrorMeassage = {
                state: _error_state,
                type: _error_msg,
                message: _error_obj_set[_error_msg]
            };
        },
        initializeErrorMeassage () {
            this.showErrorMeassage = {
                state: false,
                type: null,
                message: null
            };
        },
        async logout () {
            await this.$store.dispatch('contractor/LogoutContractor');
            this.$router.push({ name: 'Login' });

            this.showErrorMeassage = {
                state: false,
                type: null,
                message: null
            };
        }
    }
};
</script>

<style lang="scss">
</style>
